import angular from 'angular';

import AuthController from './auth.controller';
import AuthComponent from './auth.component';
import authConfig from './auth.config';
import AuthService from './auth.service';

let authModule = angular.module('app.auth', [])
   .service('AuthService', AuthService)
   .component('auth', AuthComponent)
   .controller('AuthController', AuthController)
   .config(authConfig);

export default authModule;




// WEBPACK FOOTER //
// ./www/components/auth/auth.js